export default {
  sendMessage: {
    id: 'asp_seller_action_bar_actions_list_step_send_message_action',
    defaultMessage: 'Send message',
  },
  replyToAgent: {
    id: 'asp_seller_action_bar_actions_list_step_reply_to_agent_action',
    defaultMessage: 'Reply to agent',
  },
}
